



















































import { Component, Vue } from 'vue-property-decorator'
import { AppModule } from '@/store/modules/app'
import { UserModule } from '@/store/modules/user'
import Breadcrumb from '@/components/Breadcrumb/index.vue'
import Hamburger from '@/components/Hamburger/index.vue'
import ChangePwd from '@/views/login/user/changePwd.vue'

@Component({
  name: 'Navbar',
  components: {
    Breadcrumb,
    Hamburger,
    ChangePwd
  }
})
export default class extends Vue {
  dropdownMenuList = [
    {
      path: '/changeAvatar',
      name: '修改头像',
    },
    {
      path: '/changePwd',
      name: '修改密码',
    },
    {
      path: '/userStory',
      name: '故事线选择',
    },
    {
      path: '/changePermission',
      name: '选择许可证',
    },
    {
      path: '/select',
      name: '客户管理',
    },
  ];

  get systemData () {
    return UserModule.userInfo
  }

  get sidebar () {
    return AppModule.sidebar
  }

  get device () {
    return AppModule.device.toString()
  }

  get avatar () {
    return UserModule.userInfo.avatar
  }

  private mAvatar () {
    this.$router.push('/changeAvatar')
  }

  private mPwd () {
    this.$router.push('/changePwd')
  }

  private toggleSideBar () {
    AppModule.ToggleSideBar(false)
  }

  private async logout () {
    await UserModule.LogOut()
    this.$router.push(`/login?redirect=${this.$route.fullPath}`)
  }

  toPage () {
    this.$router.push({
      path: '/useExplain',
    })
  }
}
